import { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ViewPdfIframe = ({
  file,
  open,
  handleClose,
  title,
  dialogProps,
  dialogTitleProps,
  dialogContentProps,
  isLoading = false,
  children,
  reduceIframeHeigth = { phone: 100, desktop: 180 },
}) => {
  const [blobUrl, setBlobUrl] = useState('');
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.only('xs'));
  const frameHeight = `calc(100vh - ${isPhone ? reduceIframeHeigth.phone : reduceIframeHeigth.desktop}px)`;

  useEffect(() => {
    if (!file) return;

    let url = file;

    if (file instanceof Blob) {
      url = URL.createObjectURL(file);
    }

    setBlobUrl(url);

    return () => {
      if (file instanceof Blob) {
        URL.revokeObjectURL(url);
      }
    };
  }, [file]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      fullScreen={isPhone}
      {...(!isPhone && { maxWidth: 'md' })}
      {...dialogProps}
    >
      <DialogTitle sx={{ ...dialogTitleProps, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <Skeleton variant="rectangular" animation="wave" width="100%" height="800px" />
        </Box>
      ) : (
        <DialogContent sx={{ p: 0, pt: 0, ...(dialogContentProps?.sx || {}) }} {...dialogContentProps}>
          <Box display="flex" sx={{ height: frameHeight }}>
            <iframe src={blobUrl} width="100%" height="100%" style={{ border: 'none' }} title="PDF Preview" />
          </Box>
        </DialogContent>
      )}

      <Box>{children}</Box>
    </Dialog>
  );
};

export default ViewPdfIframe;
